export const getQuotasSchedule = () => ({ quota: 5, enabledSegment: false });



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/quotaSchedule.js